import { type Enum } from '@webapp/infrastructure/types/Enum'

export const OrderDraftPreferredCreationFlows = {
  CLASSIC: 'classic',
  AI: 'AI',
} as const

export type OrderDraftPreferredCreationFlowEnum = Enum<
  typeof OrderDraftPreferredCreationFlows
>
